module.exports = __webpack_public_path__ + "img/horseback-riding--icon--gray.acc07e71.svg";